var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('style-provider',[_c('div',{staticClass:"main-view"},[_c('the-app',{attrs:{"sap-customer-id":_vm.sapCustomerId,"sap-customer-email":_vm.sapCustomerEmail,"region":_vm.region,"env":{ context: _vm.env },"lang":_vm.languageInUse},on:{"logolib:close":function($event){return _vm.$emit('logolib:close')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }